import { render, staticRenderFns } from "./JAreaLinkage.vue?vue&type=template&id=c4b17870&scoped=true&"
import script from "./JAreaLinkage.vue?vue&type=script&lang=js&"
export * from "./JAreaLinkage.vue?vue&type=script&lang=js&"
import style0 from "./JAreaLinkage.vue?vue&type=style&index=0&id=c4b17870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b17870",
  null
  
)

export default component.exports